import { ExportOutlined } from "@ant-design/icons";
import { privilegeLink } from "@p0security/shared/assessment/render";
import { ProviderOrAll } from "@p0security/shared/types/assessment";
import Link from "antd/lib/typography/Link";
import { GraphTooltip } from "components/GraphTooltip";

import { LinkDetailsSpan, LinkDiv, LinkNameSpan } from "./LinkDiv";

/** Renders a link to the IAM Risk Catalog for a privilege
 *
 * If the privilege is remediated by currently selected recommendations,
 * will render struck-through.
 */
export const PrivilegeLink: React.FC<{
  privilege: string;
  provider: ProviderOrAll;
}> = ({ privilege, provider }) =>
  provider === "all" || provider === "custom" ? (
    <>{privilege}</>
  ) : (
    <LinkDiv>
      <GraphTooltip title={privilege}>
        <LinkNameSpan>{privilege}</LinkNameSpan>
      </GraphTooltip>
      <LinkDetailsSpan>
        <Link href={privilegeLink(provider, privilege)} target="catalog">
          <ExportOutlined />
        </Link>
      </LinkDetailsSpan>
    </LinkDiv>
  );
